import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=7dedde20&scoped=true"
import script from "./ProjectForm.vue?vue&type=script&lang=ts"
export * from "./ProjectForm.vue?vue&type=script&lang=ts"
import style0 from "./ProjectForm.vue?vue&type=style&index=0&id=7dedde20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dedde20",
  null
  
)

export default component.exports